import React, {PropTypes} from "react";

const SummaryTable = (props) => {
  return (
    <div className="col-md-5" style={{paddingRight: 0, marginTop: '1%'}}>

      <div className="inner-col-wrap">

        <table className="table table-bordered" cellpadding="0" cellspacing="0" border="0">
          <thead>
          <tr>
            <th>Earned Leave Summary</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Your Leave Balance</td>
            <td>{props.props.balance}</td>
          </tr>
          <tr>
            <td>Leaves Applied</td>
            <td>{props.props.appliedLeave}</td>
          </tr>
          <tr>
            <td>Leaves Approved</td>
            <td>{props.props.approvedLeave}</td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  );

}

SummaryTable.proptypes = {};

export default SummaryTable;



/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveApply/SummaryTable.js
 **/